import { Request } from '../utils';

const cityPrefix = 'city';
const districtPrefix = 'district';
const regionPrefix = 'region';

// GET City List - without pagination
export const getCityListWithoutPagination = () => {
  return Request.get(`common/${cityPrefix}`);
};

// GET City List
export const getCityList = queries => {
  const { limit, skip, orderBy, sortBy, name, plate_code } = queries;
  const params = new URLSearchParams();

  params.append('limit', limit);
  params.append('skip', skip);
  !!orderBy && params.append('order_by', orderBy);
  !!sortBy && params.append('sort_by', sortBy);
  !!name && params.append('name', name);
  !!plate_code && params.append('plate_code', plate_code);

  return Request.get(`${cityPrefix}`, { params });
};

// GET District List - without pagination
export const getDistrictListWithoutPagination = (queries, cityId) => {
  const { filter } = queries;
  const params = new URLSearchParams();

  !!filter && params.append('filter', filter);

  return Request.get(`${districtPrefix}/${cityPrefix}/${cityId}`, { params });
};

// GET District List
export const getDistrictList = queries => {
  const { limit, skip, orderBy, sortBy, filter, city_id } = queries;
  const params = new URLSearchParams();

  params.append('limit', limit);
  params.append('skip', skip);
  params.append('city_id', city_id);
  !!orderBy && params.append('order_by', orderBy);
  !!sortBy && params.append('sort_by', sortBy);
  !!filter && params.append('filter', filter);

  return Request.get(`${districtPrefix}`, { params, errorOnly: true });
};

// GET - Regions List - without pagination
export const getRegionListWithoutPagination = (queries, cityId, districtId) => {
  const { filter } = queries;
  const params = new URLSearchParams();

  !!filter && params.append('filter', filter);

  return Request.get(`${regionPrefix}/city/${cityId}/district/${districtId}`, {
    params,
    errorOnly: true
  });
};

// GET Region List
export const getRegionList = queries => {
  const { limit, skip, orderBy, sortBy, filter, city_id, district_id } = queries;
  const params = new URLSearchParams();

  params.append('limit', limit);
  params.append('skip', skip);
  params.append('city_id', city_id);
  params.append('district_id', district_id);
  !!orderBy && params.append('order_by', orderBy);
  !!sortBy && params.append('sort_by', sortBy);
  !!filter && params.append('filter', filter);

  return Request.get(`${regionPrefix}`, { params, errorOnly: true });
};
